const getBuildNumber = () => '1';

const getDeviceId = () => 1;

const isDeviceProtected = () => {
  return false;
};

const getScreenDimensions = () => {
  return { width: 100, height: 100 };
};

/**
 * Returns a number corresponding to the devices width multiplied by a percentage
 */
const widthPercentage = (percentage: number) => {
  return 100;
};

/**
 * Returns a number corresponding to the devices height multiplied by a percentage
 */
const heightPercentage = (percentage: number) => {
  return 100;
};

const isIOS = () => false;

const isAndroid = () => false;

const isSimulator = () => false;

const DeviceInfoServices = {
  getBuildNumber,
  getDeviceId,
  isDeviceProtected,
  getScreenDimensions,
  isSimulator,
  widthPercentage,
  heightPercentage,
  isIOS: isIOS(),
  isAndroid: isAndroid()
};

export default DeviceInfoServices;
